import {Swiper, Pagination} from 'swiper';
import variables from '../../../variables';
import gsap from 'gsap';
import {$dom} from '../../../helpers/dom';
import {$events} from '../../../helpers/events';
import is from 'is_js';
import {isElement} from '../../../helpers/_utilities';
import {$style} from '../../../helpers/style';

Swiper.use([Pagination]);

const {
	active
} = variables.classNames;

const {md, lg, xl} = variables.breakpoints;

const {
	get,
	getAll,
	attr,
	each,
	hasClass,
	removeClass,
	addClass
} = $dom;

const {
	customSelectSelector
} = variables.selectors;

const {
	offset
} = $style;

export default function statisticsTables(
	sectionSelector = '.js-statistics-tables',
	carouselTargetSelector = '.js-statistics-tables-carousel',
	carouselPaginationSelector = '.js-statistics-tables-carousel-pagination',
	secondarySelectClassName = 'js-is-secondary-tables-select',
	boundAttr = 'data-bound-choice'
) {

	let swiper, slides, currentAttr, selects;

	const
		findRequiredSide = attrVal => {
			if (is.array(slides)) return slides.find(slide => attr(slide, boundAttr) === attrVal);
			return null;
		},
		swiperCreated = () => swiper instanceof Swiper,
		changeSlideByChoice = (attrVal, immediately = false) => {
			currentAttr = attrVal;

			const requiredSlide = findRequiredSide(currentAttr);

			if (isElement(requiredSlide)) {
				const indOf = slides.indexOf(requiredSlide);
				if (indOf !== -1) {
					if (swiperCreated()) {
						swiper.slideTo(indOf, immediately ? 0 : variables.carouselDefaultDuration);
					} else {
						let otherSlides = slides.filter(slide => slide !== requiredSlide);

						gsap.set(otherSlides, {display: 'none'});
						removeClass(otherSlides, active);

						gsap.set(requiredSlide, {display: 'block'});
						addClass(requiredSlide, active);
					}
				}
			}
		},
		updateSelectsValues = (value, target = null) => {
			let targetSelects;

			if (is.null(target)) {
				targetSelects = selects
			} else {
				if (isElement(target)) {
					targetSelects = [target]
				} else {
					targetSelects = target
				}
			}

			each(targetSelects, select => select.choices.setChoiceByValue(value))
		},
		changeSlideByChoiceEvent = ({target, detail}) => {
			if (isElement(target.closest(sectionSelector))) {
				const {value} = detail.choice;
				changeSlideByChoice(value);
				updateSelectsValues(value, selects.filter(s => s !== target));

				if (hasClass(target, secondarySelectClassName)) {
					window.scrollTo({
						top: offset(sectionSelector).top - variables.dom.header.offsetHeight,
						behavior: 'smooth'
					})
				}
			}
		},
		createCarousel = () => {
			return new Swiper(carouselTargetSelector, {
				slideActiveClass: active,
				speed: variables.carouselDefaultDuration,
				pagination: {
					el: carouselPaginationSelector,
					type: 'bullets',
					clickable: true,
					dynamicBullets: true
				},
				breakpoints: {
					0: {
						spaceBetween: 10
					},
					[md]: {
						spaceBetween: 20
					},
					[lg]: {
						spaceBetween: 30
					},
					[xl]: {
						spaceBetween: 60
					}
				},
				on: {
					afterInit() {
						updateSelectsValues(attr(this.slides[this.activeIndex], boundAttr));
					},
					slideChange() {
						updateSelectsValues(attr(this.slides[this.activeIndex], boundAttr));
					}
				}
			})
		},
		setView = () => {
			if (is.undefined(slides)) slides = getAll('.swiper-slide', sectionSelector);
			if (is.undefined(selects)) selects = getAll(customSelectSelector, sectionSelector);
			if (is.undefined(currentAttr)) currentAttr = selects[0].choices.getValue().value;

			gsap.set(sectionSelector, {clearProps: 'paddingBottom'});

			if (variables.windowWidth >= lg) {
				gsap.set(carouselPaginationSelector, {clearProps: 'opacity,visibility'});
				if (is.array(slides)) gsap.set(slides, {clearProps: 'display'});

				if (swiperCreated()) {
					swiper.update()
				} else {
					swiper = createCarousel();
				}

			} else {
				if (swiperCreated()) swiper.destroy(true, true);
				swiper = undefined;
				gsap.set(carouselPaginationSelector, {autoAlpha: 0});

				each(selects, select => {
					if (hasClass(select, secondarySelectClassName)) {
						gsap.set(sectionSelector, {
							paddingBottom: get(
								'.'+variables.commonChoiceOpts.classNames.listDropdown,
								select.closest('div.select')
							).offsetHeight
						})
					}
				})
			}

			changeSlideByChoice(currentAttr, true);
		},
		init = () => {
			$events.delegate.on('choice', customSelectSelector, changeSlideByChoiceEvent);
		},
		destroy = () => {
			removeClass(slides, active);
			if (swiperCreated()) swiper.destroy(true, true);
			swiper = undefined;
			slides = undefined;
			currentAttr = undefined;
			$events.delegate.off('choice', customSelectSelector, changeSlideByChoiceEvent)
		}
	;


	return {init, destroy, setView}
}
